import { render, staticRenderFns } from "./BeTakenOverModalNew.vue?vue&type=template&id=2608d253&scoped=true&"
import script from "./BeTakenOverModalNew.vue?vue&type=script&lang=js&"
export * from "./BeTakenOverModalNew.vue?vue&type=script&lang=js&"
import style0 from "./BeTakenOverModalNew.vue?vue&type=style&index=0&id=2608d253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608d253",
  null
  
)

export default component.exports